export default "__VITE_ASSET__D1tOY62f__"